

import React, { useState } from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import Modal from "@mui/material/Modal"; // for image preview
import './styles/commonStyle.css'

const FilePreview = ({ file ,fileName }) => {
  const [previewImage, setPreviewImage] = useState(null);
  const fileExtension = file.fileUrl.split('.').pop().toLowerCase();
  const handlePdfClick = (file) => {
    window.open(file.fileUrl, "_blank");
  };

  const handleImageClick = (file) => {
    setPreviewImage(file.fileUrl);
  };

  const renderFilePreview = (file) => {
    if (['jpg', 'jpeg', 'png'].includes(fileExtension)) {
      return (
        <img
          src={file.fileUrl}
          alt="uploaded"
          className="w-32 h-32 object-cover cursor-pointer rounded shadow"
          onClick={() => handleImageClick(file)}
        />
      );
    } else if (fileExtension === 'pdf') {
      return (
        <div
          className="flex flex-col items-center justify-center w-32 h-32 border rounded shadow cursor-pointer hover:bg-gray-100"
          onClick={() => handlePdfClick(file)}
        >
          <PictureAsPdfIcon style={{ fontSize: 40 }} color="error" />
          <p className="text-xs text-center mt-2 px-1">{file.name}</p>
        </div>
      );
    } else {
      return <p className="text-red-500 text-xs">Unsupported file</p>;
    }
  };

  return (
    <>
      <div>{renderFilePreview(file)}</div>
      <Modal open={!!previewImage} onClose={() => setPreviewImage(null)}>
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50"
          onClick={() => setPreviewImage(null)}
        >
          <div
            className="relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setPreviewImage(null)}
              className="absolute top-2 right-2 text-white text-3xl font-bold z-10"
              aria-label="Close Preview"
            >
              &times;
            </button>

            {/* Image */}
            <img
              src={previewImage}
              alt="Preview"
              className="max-w-[90vw] max-h-[90vh] rounded-lg shadow-lg"
            />
          </div>
        </div>
      </Modal>


    </>
  );
};

export default FilePreview;
